module.exports = __webpack_public_path__ + "media/images/page/photo_s3-396b55c1a9919bc40e3269e5ec14a349.jpg";